"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = get;
exports.post = post;
exports.postMultiple = postMultiple;
exports.put = put;
exports.deleteRequest = deleteRequest;
const InsightApiResponse_1 = require("./InsightApiResponse");
const axios_1 = __importDefault(require("axios"));
const retryAxios = __importStar(require("retry-axios"));
const ApiErrors_1 = require("../errortypes/ApiErrors");
function AttachAxiosRetry() {
    axios_1.default.defaults.raxConfig = {
        backoffType: 'exponential',
        retry: 3,
        noResponseRetries: 2
    };
    retryAxios.attach();
    return axios_1.default;
}
const axios = AttachAxiosRetry();
async function get(url, token) {
    const requestConfig = {};
    // If provided, add the token to the Authorization header
    if (token) {
        requestConfig.headers = {
            Authorization: token
        };
    }
    let apiRequest;
    try {
        apiRequest = await axios.get(url, requestConfig);
    }
    catch (error) {
        tryThrowAsApiError(error);
    }
    throwIfError(apiRequest);
    // Assign the response from the API to the InsightApiResponse class
    const response = new InsightApiResponse_1.InsightApiResponse(apiRequest.data);
    return response.data;
}
async function post(url, body, token) {
    let apiRequest;
    try {
        apiRequest = await axios.post(url, body, configureRequest(token));
    }
    catch (error) {
        tryThrowAsApiError(error);
    }
    throwIfError(apiRequest);
    const response = new InsightApiResponse_1.InsightApiResponse(apiRequest.data);
    return response.data;
}
async function postMultiple(requests) {
    const responsesPromises = [];
    for (const request of requests) {
        responsesPromises.push(axios.post(request.url, request.body, configureRequest(request.token)));
    }
    const responses = await Promise.all(responsesPromises);
    const insightApiResponses = responses.map((r) => {
        throwIfError(r);
        return new InsightApiResponse_1.InsightApiResponse(r.data);
    });
    return insightApiResponses
        .map((d) => d.data)
        .reduce((acc, curr) => acc.concat(curr), []);
}
async function put(url, body, token) {
    let apiRequest;
    try {
        apiRequest = await axios.put(url, body, configureRequest(token));
    }
    catch (error) {
        tryThrowAsApiError(error);
    }
    throwIfError(apiRequest);
    const response = new InsightApiResponse_1.InsightApiResponse(apiRequest.data);
    return response.data;
}
// The reason of why `deleteRequest` was used instead of just `delete` is
// because it seems that `delete` is a reserved word and cannot be used
// to name this function.
async function deleteRequest(url, token) {
    let apiRequest;
    try {
        apiRequest = await axios.delete(url, configureRequest(token));
    }
    catch (error) {
        tryThrowAsApiError(error);
    }
    throwIfError(apiRequest);
    const response = new InsightApiResponse_1.InsightApiResponse(apiRequest.data);
    return response.data;
}
function configureRequest(token) {
    const requestConfig = {};
    if (token) {
        requestConfig.headers = {
            Authorization: token,
            'Content-Type': 'application/json;charset=UTF-8'
        };
    }
    else {
        requestConfig.headers = {
            'Content-Type': 'application/json;charset=UTF-8'
        };
    }
    return requestConfig;
}
function throwIfError(response) {
    if (response.data.ok) {
        return;
    }
    else {
        toErrorType(response.data.errorCode, response.data.errorMessage, response.data.canRetry);
    }
}
function tryThrowAsApiError(axiosError) {
    if (!axiosError.response.data) {
        throw new Error(axiosError.code);
    }
    else {
        toErrorType(axiosError.response.data.errorCode, axiosError.response.data.message);
    }
}
function toErrorType(errorCode, errorMessage, canRetry = false) {
    switch (errorCode) {
        case 'TOKEN_INVALID':
            throw new ApiErrors_1.TokenInvalidError(errorCode, errorMessage, canRetry);
        case 'TOKEN_EXPIRED':
            throw new ApiErrors_1.TokenExpiredError(errorCode, errorMessage, canRetry);
        default:
            throw new Error(errorCode);
    }
}
//# sourceMappingURL=api.js.map